import React from "react";
// import img404 from "../assets/images/404.png";
import img404 from "../assets/images/error-01.png";
import Button from "../components/form/Button";

const PageNotFound = () => {
  return (
    // <div className="flex h-screen bg-gradient-to-l from-purple-50 to-blue-100 px-20">
    //   <div className="w-full flex items-center justify-end">
    //     <div className="relative w-[600px] h-[600px]">
    //       <img
    //         width={800}
    //         height={800}
    //         src={img404}
    //         alt="invalid"
    //         className="w-full h-full object-contain object-center"
    //       />
    //     </div>
    //   </div>
    //   <div className="w-full flex flex-col justify-center">
    //     <div className="-ml-20 mt-20 relative">
    //       <div className="text-3xl font-bold text-red-700">
    //         It&apos;s seems you&apos;ve taken a wrong turn
    //       </div>
    //       <div className="font-medium my-3">
    //         the page you&apos;re looking for might have been misplaced,
    //         <br />
    //         lost in cyperspace, or it simply doesn&apos;t exiist
    //       </div>
    //       <div className="absolute -bottom-60 right-[300px] text-[200px] text-red-400/40 font-extrabold">
    //         404
    //       </div>
    //       <Button
    //         buttonHasLink={true}
    //         buttonLink={"/"}
    //         buttonClasses={"!w-fit !bg-primary !border-primary !text-white"}
    //         buttonLabel={"Go to home page"}
    //       />
    //     </div>
    //   </div>
    // </div>

    <div className="flex flex-col lg:flex-row h-screen w-full bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-50 px-5 md:px-20 relative overflow-hidden gap-10">
      <div className="absolute -top-24 -left-24 w-[400px] h-[400px] bg-gradient-to-r from-purple-400 to-pink-400 opacity-30 blur-3xl rounded-full animate-pulse"></div>
      <div className="w-full lg:w-1/2 flex items-center justify-center">
        <div className="relative w-full h-full animate-float p-10 lg:p-0">
          <img
            src={img404}
            alt="404 illustration"
            className="w-full h-full object-contain object-center drop-shadow-xl"
          />
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex flex-col justify-center lg:pl-10">
        <div className="relative space-y-6">
          <div className="relative z-20">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-800 mb-8">
              Oops! Lost in Space
            </h1>

            <p className="text-gray-700 text-lg leading-loose mb-6">
              It seems you’ve wandered into the void. The page you’re looking
              for might have been moved, deleted, or never existed.
            </p>

            <div className="flex items-center gap-4 mt-4">
              <Button
                buttonHasLink={true}
                buttonLink="/"
                buttonClasses="!w-fit !bg-gradient-to-r from-purple-600 to-blue-600 !text-white !border-none hover:scale-105 transition-transform shadow-lg"
                buttonLabel={"Go to home page"}
              />
            </div>
          </div>

          <div className="absolute -bottom-40 right-0 text-[150px] md:text-[250px] font-extrabold text-purple-400/20 select-none pointer-events-none z-10">
            404
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
